<template>
  <main>
    <div class="container-fluid">
      <div class="page-header min-height-300" style="margin-right: -24px; margin-left: -34%;">
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <i class="fas fa-user-lock text-warning opacity-10"></i>
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">비밀번호 변경</h5>
                <p class="mb-0 font-weight-bold text-sm">본인의 비밀번호를 변경합니다.</p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <button class="btn btn-success btn-sm ms-auto" @click="changePassword">변경</button>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-md fw-bold">현재 비밀번호와 변경할 비밀번호를 입력해주세요</p>
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <label for="curPW" class="form-control-label">현재 비밀번호</label>
                    <input id="curPW" class="form-control invalid" type="password" v-model="curPW" placeholder="현재 비밀번호"/>
                  </div>
                  <div class="col-md-12 mb-2">
                    <label for="newPW01" class="form-control-label">변경할 비밀번호</label>
                    <input id="newPW01" class="form-control invalid" type="password" v-model="newPW01" placeholder="변경할 비밀번호"/>
                  </div>
                  <div class="col-md-12 mb-2">
                    <label for="newPW02" class="form-control-label">변경할 비밀번호 확인</label>
                    <input id="newPW02" class="form-control invalid" type="password" v-model="newPW02" placeholder="변경할 비밀번호 확인"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </main>
</template>

<script>
export default {
    name: 'changePassword',
    data(){
        return {
            curPW: '',
            newPW01: '',
            newPW02: '',
        }
    },
    methods:{
        changePassword(){
            if(this.newPW01 == this.newPW02){
                this.$store.commit('setAlert', {
                                                    'alertStatus': 'confirm'
                                                    ,'alertTitle': '비밀번호 변경'
                                                    ,'alertContent': `비밀번호를 변경하시겠습니까?| |** 변경 완료 후 자동으로 로그아웃 됩니다.`
                                                    ,'callback': 'changePassword'
                                                    ,'parameter': {
                                                                        curPW: this.curPW,
                                                                        newPW01: this.newPW01,
                                                                        newPW02: this.newPW02,
                                                                        updateDT: new Date().toLocaleString()
                                                                    }
                                                }
                                    );
            }else{
                this.$store.commit('setAlert', {
                                                    'alertStatus': 'notice'
                                                    ,'alertTitle': '비밀번호 변경'
                                                    ,'alertContent': `변경할 비밀번호를 다시 확인해주세요`
                                                });
            }
            
        }
    },
}
</script>

<style>

</style>